module.exports = __webpack_public_path__ + "img/icon-no-member-img.936eaafb.svg";